import { Promise } from "../../../../../react-core/Async/Promise";
import { GetUserUIThemeClient } from "../../../../../Wrap/Api/User/GetUserUITheme";
import { PhotoInformation } from "../Resources/PhotoInformation";
import * as $ from "jquery";
import { CompanyLogo } from "../../../../../Wrap/Models/Domains/Company/CompanyLogo";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";

export class UIThemeAction {
    public static getUITheme(callback) {
        const client = new GetUserUIThemeClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static setUITheme(isLightMode: boolean, callback) {
        const client = new GetUserUIThemeClient();
        const promise = client.put(isLightMode);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getLogoUrl(logo: CompanyLogo, isDark?: boolean) {
        const isDarkMode =
            isDark || document.getElementById("stylesheetLink").getAttribute("href").includes("dark-blue");
        const styleObj = !CommonHelper.isNullOrEmpty(logo?.UploadUrl)
            ? { backgroundImage: `url(${isDarkMode ? logo.UploadDarkModeUrl : logo.UploadUrl})` }
            : !CommonHelper.isNullOrEmpty(logo?.LocalUrl)
            ? isDarkMode
                ? {}
                : {
                      backgroundImage: `url(${logo.LocalUrl})`,
                  }
            : {};
        return styleObj;
    }

    public static getThumbnails(
        clientId: string,
        collectionId: string,
        currentPage: number,
        callback: (response: PhotoInformation[]) => void
    ): Promise<string, any> {
        const ajaxParameters = {
            type: "GET",
            url: `https://api.unsplash.com/collections/${collectionId}/photos?&orientation=landscape&page=${currentPage}&per_page=29`,
            data: {},
            accepts: { key: "application/json" },
            dataType: "json",
            headers: { Authorization: `Client-ID ${clientId}` },
        };

        return new Promise(() => {
            $.ajax(ajaxParameters).then((data: any) => {
                if (data.Errors && data.Errors.length && data.Errors.length > 0) {
                    callback(null);
                } else {
                    callback(data);
                }
            });
        });
    }
}
